<script setup>
import CustomerForm from "@frontJs/components/forms/projectManagement/customers/CustomerForm.vue";
import ProjectManagementLayout from "@frontJs/layouts/ProjectManagementLayout.vue";
import { Head } from "@inertiajs/vue3";
import PageTitle from "@js/components/titles/PageTitle.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  tenant: {
    type: Object,
    required: false,
  },
  seoPackages: {
    type: Array,
    required: true,
  },
  seaPackages: {
    type: Array,
    required: true,
  },
  smoPackages: {
    type: Array,
    required: true,
  },
  smaPackages: {
    type: Array,
    required: true,
  },
  semPackages: {
    type: Array,
    required: true,
  },
  devPackages: {
    type: Array,
    required: true,
  },
  hostingPackages: {
    type: Array,
    required: true,
  },
  outsourcingPackages: {
    type: Array,
    required: true,
  },
  cloudflarePackages: {
    type: Array,
    required: true,
  },
  emailingPackages: {
    type: Array,
    required: true,
  },
  shoppingfeedPackages: {
    type: Array,
    required: true,
  },
  performanceStagePackages: {
    type: Array,
    required: true,
  },
  performancePercentagePackages: {
    type: Array,
    required: true,
  },
  specialPackages: {
    type: Array,
    required: true,
  },
  moduleTree: {
    type: Object,
    required: true,
  },
  websiteVariants: {
    type: Array,
    required: true,
  },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
  <Head>
    <title v-if="props.tenant">
      {{ t("all.title.updateCustomer", { id: props.tenant.id }) }} -
      {{ t("all.title.customers") }} - {{ t("all.title.projectManagement") }} -
      {{ t("all.title.datakepler") }}
    </title>

    <title v-else>
      {{ t("all.title.createCustomer") }} - {{ t("all.title.customers") }} -
      {{ t("all.title.projectManagement") }} - {{ t("all.title.datakepler") }}
    </title>
  </Head>

  <PageTitle v-if="props.tenant">
    {{ t("all.title.projectManagement") }} - {{ t("all.title.customers") }} -
    {{ t("all.title.updateCustomer", { id: props.tenant.id }) }}
  </PageTitle>

  <PageTitle v-else>
    {{ t("all.title.projectManagement") }} - {{ t("all.title.customers") }} -
    {{ t("all.title.createCustomer") }}
  </PageTitle>

  <CustomerForm
    :tenant="props.tenant"
    :seo-packages="props.seoPackages"
    :sea-packages="props.seaPackages"
    :smo-packages="props.smoPackages"
    :sma-packages="props.smaPackages"
    :sem-packages="props.semPackages"
    :dev-packages="props.devPackages"
    :hosting-packages="props.hostingPackages"
    :outsourcing-packages="props.outsourcingPackages"
    :cloudflare-packages="props.cloudflarePackages"
    :emailing-packages="props.emailingPackages"
    :shoppingfeed-packages="props.shoppingfeedPackages"
    :performance-stage-packages="props.performanceStagePackages"
    :performance-percentage-packages="props.performancePercentagePackages"
    :special-packages="props.specialPackages"
    :module-tree="props.moduleTree"
    :website-variants="props.websiteVariants"
  />
</template>
